import React from 'react';

import { Icon } from '../icons';

export const ArrowDownBisIcon: Icon['component'] = ({ color, style, ...props }) => {
  return (
    <svg {...props} viewBox="0 0 16 16" fill={color} style={style}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.4953 7.09022L15.2578 7.85822C15.5807 8.18341 15.5807 8.70924 15.2578 9.03097L8.58392 15.7561C8.26105 16.0813 7.73895 16.0813 7.41951 15.7561L0.742157 9.03097C0.419281 8.70578 0.419281 8.17995 0.742157 7.85822L1.50469 7.09022C1.831 6.76158 2.36341 6.7685 2.68285 7.10406L6.62606 11.2727L6.62606 1.33026C6.62606 0.870159 6.99359 0.5 7.45042 0.5L8.54958 0.5C9.00641 0.5 9.37394 0.87016 9.37394 1.33026L9.37394 11.2727L13.3172 7.10406C13.6366 6.76504 14.169 6.75812 14.4953 7.09022Z"
      />
    </svg>
  );
};
